module.exports = __webpack_public_path__ + "img/intellimat-1.306aa353.png";